<template>
  <section id="payment-result">
    <div class="result-container">
      <!-- Success -->
      <div v-if="status === 'success'" class="result-card success">
        <div class="result-icon">
          <v-icon size="64" color="white">mdi-check-circle</v-icon>
        </div>
        <h2>پرداخت موفق</h2>
        <p class="result-message">تراکنش شما با موفقیت انجام شد و اشتراک دستگاه تمدید گردید.</p>

        <div class="result-details">
          <div class="detail-item">
            <span class="label">شماره سفارش:</span>
            <span class="value">#{{ orderId }}</span>
          </div>
          <div v-if="refNumber" class="detail-item">
            <span class="label">شماره مرجع:</span>
            <span class="value">{{ refNumber }}</span>
          </div>
        </div>

        <div class="result-actions">
          <b-button variant="primary" size="lg" @click="goToTransactions">
            مشاهده تراکنش‌ها
          </b-button>
          <b-button variant="outline-primary" size="lg" @click="goHome">
            بازگشت به خانه
          </b-button>
        </div>
      </div>

      <!-- Failed -->
      <div v-else-if="status === 'failed'" class="result-card failed">
        <div class="result-icon">
          <v-icon size="64" color="white">mdi-close-circle</v-icon>
        </div>
        <h2>پرداخت ناموفق</h2>
        <p class="result-message">{{ message || 'متأسفانه پرداخت شما با مشکل مواجه شد.' }}</p>

        <div v-if="orderId" class="result-details">
          <div class="detail-item">
            <span class="label">شماره سفارش:</span>
            <span class="value">#{{ orderId }}</span>
          </div>
        </div>

        <div class="result-actions">
          <b-button variant="primary" size="lg" @click="retry">
            تلاش مجدد
          </b-button>
          <b-button variant="outline-secondary" size="lg" @click="goHome">
            بازگشت به خانه
          </b-button>
        </div>
      </div>

      <!-- Error -->
      <div v-else class="result-card error">
        <div class="result-icon">
          <v-icon size="64" color="white">mdi-alert-circle</v-icon>
        </div>
        <h2>خطا</h2>
        <p class="result-message">{{ message || 'خطایی در پردازش درخواست رخ داد.' }}</p>

        <div class="result-actions">
          <b-button variant="primary" size="lg" @click="goHome">
            بازگشت به خانه
          </b-button>
        </div>
      </div>

      <!-- Support Info -->
      <div class="support-info">
        <v-icon size="20" class="ml-2">mdi-headset</v-icon>
        <span>در صورت بروز مشکل با پشتیبانی تماس بگیرید</span>
      </div>
    </div>
  </section>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
  data() {
    return {
      status: 'error',
      orderId: null,
      refNumber: null,
      message: null,
    }
  },
  mounted() {
    // خواندن پارامترها از URL
    const { status, orderId, refNumber, message } = this.$route.query

    this.status = status || 'error'
    this.orderId = orderId || null
    this.refNumber = refNumber || null
    this.message = message ? decodeURIComponent(message) : null
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' })
    },
    goToTransactions() {
      this.$router.push({ name: 'payment-transactions' })
    },
    retry() {
      this.$router.push({ name: 'subscription-renew' })
    },
  },
}
</script>

<style scoped>
#payment-result {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px;
}

.result-container {
  max-width: 500px;
  width: 100%;
}

.result-card {
  background: white;
  border-radius: 24px;
  padding: 48px 32px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
}

.result-icon {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.result-card.success .result-icon {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}

.result-card.failed .result-icon {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.result-card.error .result-icon {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.result-card h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
}

.result-message {
  font-size: 15px;
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 24px;
}

.result-details {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.detail-item:not(:last-child) {
  border-bottom: 1px solid #e2e8f0;
}

.detail-item .label {
  font-size: 13px;
  color: #64748b;
}

.detail-item .value {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.result-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.result-actions .btn {
  padding: 14px 24px;
  font-size: 15px;
  border-radius: 12px;
}

.support-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  padding: 16px;
  background: white;
  border-radius: 12px;
  font-size: 13px;
  color: #64748b;
}

@media (max-width: 576px) {
  .result-card {
    padding: 32px 20px;
  }

  .result-icon {
    width: 100px;
    height: 100px;
  }

  .result-card h2 {
    font-size: 24px;
  }
}
</style>
